// This and validEmail should be refactor to a different class
import { UserService } from '@/modules/partners/services/user.service'
import { User } from '@/modules/core/models'

export enum ValidatorsTypes {
  EMAIL = 1,
  PHONE = 2,
  EMAIL_IS_UNIQUE = 3
}

export function validEmail (text: any) {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(text)
}

export async function isEmailUnique (text: any): Promise<boolean> {
  let response = await UserService.list(1, 1, { 'email': text })

  // if the number of matches is 0, then is unique
  return response[1] === 0
}

export async function isAnswerValid (validatorsTypes: Array<ValidatorsTypes>, ...args: any) : Promise<Array<any>> {
  let results = []
  let errorMessages = []
  for (let rule of validatorsTypes) {
    let text, valid

    switch (rule) {
      case ValidatorsTypes.EMAIL:
        text = args[0]
        valid = validEmail(text)
        results.push(valid)

        if (!valid) {
          errorMessages.push('Looks like that is not a valid email address, could you please review it?')
        }

        break
      case ValidatorsTypes.EMAIL_IS_UNIQUE:
        text = args[0]
        valid = await isEmailUnique(text)
        results.push(valid)

        if (!valid) {
          errorMessages.push('Looks like that is already in use 😥, did you forgot your account? If that is the case,' +
            ' please try to go back and log in, otherwise provide another email to continue')
        }

        break
    }
  }

  return [!results.some(v => v === false), errorMessages]
}
